import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {firstValueFrom, forkJoin, lastValueFrom, timer} from 'rxjs';
import { ProcesarTramiteComponent } from '../procesar-tramite.component';
import {ReciboService} from "../../../../services/recibo.service";
import {LoadingPanelService, AlertIcon, AlertService} from "lib-base";
import {ImpuestosFuente} from "../../../../../../../lib-base/src/lib/shared";

@Component({
  selector: 'app-tramite-firmado',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  template: `
    <section>
      <p-dialog [(visible)]="displayDialog" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="false"
                [maximizable]="false" [closable]="false"
                [breakpoints]="{'2000px': '686px', '1900px': '686px', '1700px': '686px',
               '1400px': '686px', '960px': '70vw', '640px': '90vw', '490px':'94vw'}">
        <ng-template pTemplate="content">
          <div class="flex flex-column gap-2 align-content-center align-items-center">
            <div>
              <i class="pi pi-check color-success" style="font-size: 2.8rem"></i>
            </div>
            <h1 class="font-bold color-blue-2 font-23 font-principal ">
              {{ translations.header }}
            </h1>
            <div class="text-sm mb-3">
              {{ translations.subHeader }}
            </div>
            <div class="pb-2">
              <p-button [label]="translations.continuar" [rounded]="true" (onClick)="continuar()"/>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
        </ng-template>
      </p-dialog>
    </section>
  `,
  styleUrl: './tramite-firmado.component.scss'
})
export class TramiteFirmadoComponent implements OnInit {
  displayDialog = false;
  translations: any = {};
  #tramRegistroSolicitudId !: number;
  private TIMER:number = 5000;

  private parent: ProcesarTramiteComponent = inject(ProcesarTramiteComponent);

  constructor(private _t: TranslateService,private _sitiGobService: ReciboService,
              private _lps: LoadingPanelService) { }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void>{
    this.translations = await firstValueFrom(forkJoin({
      continuar: this._t.get('common.continuar'),
      header: this._t.get('components.app-tramite-firmado.header'),
      subHeader: this._t.get('components.app-tramite-firmado.sub-header'),
      titleWarnMsg: this._t.get('form.msg.warn-summary'),
      messageWarnMsg: this._t.get('components.app-tramite-firmado.message-warn-factura'),
      aceptar: this._t.get('form.button.aceptar'),
    }));
  }

  showDialog(tramiRegistro: number) {
    this.#tramRegistroSolicitudId = tramiRegistro;
    this.displayDialog = true;
    timer(this.TIMER).subscribe(value => this.continuar());
  }

  hideDialog() {
    this.displayDialog = false;
  }

  async continuar() {
    this.hideDialog();
    if (!this.parent.requierePago) {
      this.parent.redirectToDetalleRadicado(this.#tramRegistroSolicitudId);
      return;
    }
    switch (this.parent.fuentePago) {
      case ImpuestosFuente.TRIBUTOS:
        await this.parent.redireccionPagosExternos(this.#tramRegistroSolicitudId);
        break;
      case  ImpuestosFuente.TRAMITES :
        this.parent.redirectToConsultaPagos(this.#tramRegistroSolicitudId);
        break
      default:
        return;
    }
  }

}
